import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  numberOfPatients: { isLoading: false, data: null, errorMessage: null },
  numberOfDoctors: { isLoading: false, data: null, errorMessage: null },
  numberOfSurgeryRooms: { isLoading: false, data: null, errorMessage: null },
  numberOfPatientSurgeries: {
    isLoading: false,
    data: null,
    errorMessage: null,
  },
  groupedBySurgeryRoomsNox: {
    isLoading: false,
    data: null,
    errorMessage: null,
  },
  numberOfUsersByRole: { isLoading: false, data: null, errorMessage: null },
  eventsByAvailabilityProcedures: {
    isLoading: false,
    data: null,
    errorMessage: null,
  },
  eventsByAvailabilityValorations: {
    isLoading: false,
    data: null,
    errorMessage: null,
  },
  averageSchedulingCompletion: {
    isLoading: false,
    data: null,
    errorMessage: null,
  },
  patientRepeatRegistrations: {
    isLoading: false,
    data: null,
    errorMessage: null,
  },
  procedureCancellations: {
    isLoading: false,
    data: null,
    errorMessage: null,
  },
  valorationCancellations: {
    isLoading: false,
    data: null,
    errorMessage: null,
  },
  hyperbaricChamberSessions: {
    isLoading: false,
    data: null,
    errorMessage: null,
  },
  patientSurgeryByTrack: {
    isLoading: false,
    data: null,
    errorMessage: null,
    filters: {
      year: new Date().getFullYear(),
      procedureId: "78763555-39b4-4433-a7f2-079dea69b64a",
    },
  },
  // Add more charts here
};

export const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {
    startLoadingChart: (state, { payload }) => {
      state[payload].isLoading = true;
      state[payload].errorMessage = null;
    },
    setChartData: (state, { payload }) => {
      const { chartId, data } = payload;
      state[chartId].isLoading = false;
      state[chartId].data = data;
    },
    setChartError: (state, { payload }) => {
      const { chartId, errorMessage } = payload;
      state[chartId].isLoading = false;
      state[chartId].errorMessage = errorMessage;
    },
    setChartFilter: (state, { payload }) => {
      const { chartId, filterKey, filterValue } = payload;
      if (state[chartId] && state[chartId].filters) {
        state[chartId].filters[filterKey] = filterValue;
        state[chartId].data = null;
      }
    },
  },
});

// Action creators are generated for each case reducer function
export const { startLoadingChart, setChartData, setChartError, setChartFilter } =
  dashboardSlice.actions;
